unit View.Fs_Prod_SubCategorias.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewFs_Prod_SubCategoriasEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFs_Prod_SubCategoriasGet: TXDataWebClient;
    Fs_Prod_SubCategoriasDataset: TXDataWebDataSet;
    Fs_Prod_SubCategoriasDatasetid: TIntegerField;
    Fs_Prod_SubCategoriasDatasetnome: TStringField;
    Fs_Prod_SubCategoriasDatasetexcluido: TBooleanField;
    Fs_Prod_SubCategoriasDatasetinclusao: TDateTimeField;
    Fs_Prod_SubCategoriasDatasetalteracao: TDateTimeField;
    Fs_Prod_SubCategoriasDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientFs_Prod_SubCategoriasGetLoad(Response: TXDataClientResponse);
    procedure Fs_Prod_SubCategoriasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_SubCategoriasEdit: TFViewFs_Prod_SubCategoriasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_SubCategoriasEdit }

procedure TFViewFs_Prod_SubCategoriasEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(ednome) then
  begin
    TUtils.SetErroClass('lbnome', 'Preencha o nome!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Fs_Prod_SubCategoriasDataset.State in dsEditModes then
    begin
      Fs_Prod_SubCategoriasDataset.Post;
      Fs_Prod_SubCategoriasDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;


class function TFViewFs_Prod_SubCategoriasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFs_Prod_SubCategoriasEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbnome');
end;

procedure TFViewFs_Prod_SubCategoriasEdit.InsertEntity;
begin
  Fs_Prod_SubCategoriasDataset.Close;
  Fs_Prod_SubCategoriasDataset.SetJsonData('{}');
  Fs_Prod_SubCategoriasDataset.Open;
  Fs_Prod_SubCategoriasDataset.Insert;
end;

class function TFViewFs_Prod_SubCategoriasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_SubCategoriasEdit(AForm).FInserting := AInserting;
    TFViewFs_Prod_SubCategoriasEdit(AForm).FId := AId;
    TFViewFs_Prod_SubCategoriasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFs_Prod_SubCategoriasEdit(AForm).InsertEntity
    else
      TFViewFs_Prod_SubCategoriasEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_SubCategoriasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_SubCategoriasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Fs_Prod_SubCategoriasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Fs_Prod_SubCategoriasDataset.EntitySetName
    )
  );
  XDataClientFs_Prod_SubCategoriasGet.Get(Fs_Prod_SubCategoriasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFs_Prod_SubCategoriasEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(Fs_Prod_SubCategoriasDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      ednome.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewFs_Prod_SubCategoriasEdit.XDataClientFs_Prod_SubCategoriasGetLoad(Response: TXDataClientResponse);
begin
  Fs_Prod_SubCategoriasDataset.Close;
  Fs_Prod_SubCategoriasDataset.SetJsonData(Response.Result);
  Fs_Prod_SubCategoriasDataset.Open;
  
  Fs_Prod_SubCategoriasDataset.Edit;  
end;

procedure TFViewFs_Prod_SubCategoriasEdit.Fs_Prod_SubCategoriasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Fs_Prod_SubCategoriasDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewFs_Prod_SubCategoriasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFs_Prod_SubCategoriasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fs_prod_subcategorias.form.lbid');
  lbnome := TLabel.Create('view.fs_prod_subcategorias.form.lbnome');
  lbexcluido := TLabel.Create('view.fs_prod_subcategorias.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fs_prod_subcategorias.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fs_prod_subcategorias.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fs_prod_subcategorias.form.lbexclusao');
  btCancel := TButton.Create('view.fs_prod_subcategorias.form.btBack');
  btSave := TButton.Create('view.fs_prod_subcategorias.form.btSave');
  edid := TDBEdit.Create('view.fs_prod_subcategorias.form.edid');
  ednome := TDBEdit.Create('view.fs_prod_subcategorias.form.ednome');
  edinclusao := TDBEdit.Create('view.fs_prod_subcategorias.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fs_prod_subcategorias.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fs_prod_subcategorias.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.fs_prod_subcategorias.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Fs_Prod_SubCategoriasDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_SubCategoriasDatasetid := TIntegerField.Create(Self);
  Fs_Prod_SubCategoriasDatasetnome := TStringField.Create(Self);
  Fs_Prod_SubCategoriasDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_SubCategoriasDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_SubCategoriasDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_SubCategoriasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFs_Prod_SubCategoriasGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDataset.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetid.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_SubCategoriasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFs_Prod_SubCategoriasGet.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_SubCategoriasEdit';
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 5;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.MaxLength := 100;
    ednome.TabOrder := 6;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 8;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 9;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 10;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 242;
    cbExcluido.Width := 113;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Fs_Prod_SubCategoriasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Fs_Prod_SubCategoriasDataset.SetParentComponent(Self);
    Fs_Prod_SubCategoriasDataset.Name := 'Fs_Prod_SubCategoriasDataset';
    Fs_Prod_SubCategoriasDataset.AfterApplyUpdates := Fs_Prod_SubCategoriasDatasetAfterApplyUpdates;
    Fs_Prod_SubCategoriasDataset.EntitySetName := 'Fs_Prod_SubCategorias';
    Fs_Prod_SubCategoriasDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_SubCategoriasDataset.Left := 176;
    Fs_Prod_SubCategoriasDataset.Top := 8;
    Fs_Prod_SubCategoriasDatasetid.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetid.Name := 'Fs_Prod_SubCategoriasDatasetid';
    Fs_Prod_SubCategoriasDatasetid.FieldName := 'id';
    Fs_Prod_SubCategoriasDatasetnome.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetnome.Name := 'Fs_Prod_SubCategoriasDatasetnome';
    Fs_Prod_SubCategoriasDatasetnome.FieldName := 'nome';
    Fs_Prod_SubCategoriasDatasetnome.Required := True;
    Fs_Prod_SubCategoriasDatasetnome.Size := 255;
    Fs_Prod_SubCategoriasDatasetexcluido.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetexcluido.Name := 'Fs_Prod_SubCategoriasDatasetexcluido';
    Fs_Prod_SubCategoriasDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_SubCategoriasDatasetinclusao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetinclusao.Name := 'Fs_Prod_SubCategoriasDatasetinclusao';
    Fs_Prod_SubCategoriasDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_SubCategoriasDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubCategoriasDatasetalteracao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetalteracao.Name := 'Fs_Prod_SubCategoriasDatasetalteracao';
    Fs_Prod_SubCategoriasDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_SubCategoriasDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubCategoriasDatasetexclusao.SetParentComponent(Fs_Prod_SubCategoriasDataset);
    Fs_Prod_SubCategoriasDatasetexclusao.Name := 'Fs_Prod_SubCategoriasDatasetexclusao';
    Fs_Prod_SubCategoriasDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_SubCategoriasDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientFs_Prod_SubCategoriasGet.SetParentComponent(Self);
    XDataClientFs_Prod_SubCategoriasGet.Name := 'XDataClientFs_Prod_SubCategoriasGet';
    XDataClientFs_Prod_SubCategoriasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFs_Prod_SubCategoriasGet, Self, 'OnLoad', 'XDataClientFs_Prod_SubCategoriasGetLoad');
    XDataClientFs_Prod_SubCategoriasGet.Left := 64;
    XDataClientFs_Prod_SubCategoriasGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDataset.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetid.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetnome.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_SubCategoriasDatasetexclusao.AfterLoadDFMValues;
    XDataClientFs_Prod_SubCategoriasGet.AfterLoadDFMValues;
  end;
end;

end.
